import React from "react";
import { Box, makeStyles } from "@material-ui/core";

export interface FormHeaderProps {
  children: React.ReactNode;
}

export const useStyles = makeStyles(
  (theme) => ({
    header: {
      "& .title": {
        display: "block",
        fontSize: "1.2rem",
        fontWeight: 600,
        textAlign: "left",
      },

      "& .subTitle": {
        display: "block",
        fontSize: "0.8rem",
        fontWeight: 400,
        textAlign: "left",
      },
    },
  }),
  {
    name: "signup-header-style",
    flip: null,
  }
);

export const FormHeader = (props: FormHeaderProps) => {
  const classes = useStyles(props);
  // Props
  const { children } = props;

  return (
    <Box
      className={classes.header}
      display="flex"
      alignItems="center"
      justifyContent="space-between"
    >
      {children}
    </Box>
  );
};
